<template>
  <div class="nothingArea">
    <Alert :text="label + 'している病院はありません'" />
    <section v-if="items.length > 0">
      <HeadingLv3
        :text="`${$store.state.userInfo.name}さん、オススメ研修先病院`"
      />
      <ul>
        <template v-for="(item, i) in items" :key="i">
          <HospitalCassette :detail="item" />
        </template>
      </ul>
    </section>
  </div>
</template>

<script lang="ts">
import Alert from '@/components/elements/Alert.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import HospitalCassette from '@/components/block/HospitalCassette.vue'

export default {
  name: 'NothingArea',

  components: {
    Alert,
    HeadingLv3,
    HospitalCassette
  },

  props: {
    label: String,
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.nothingArea {
  .noitemTxt {
    margin-top: 50px;
    margin-bottom: 60px;
    text-align: center;
    font-weight: bold;
    color: var.$color-main-text;
  }
  .headingLv3 {
    margin-bottom: 30px;
  }
  > ul {
    margin-bottom: 80px;
  }
  .hospitalCassette + .hospitalCassette {
    margin-top: 47px;
  }
}
</style>
